import { getUserInitials } from "./responsiveHelpers.js";

/**
 * 🎨 Employee Formatters & Mappers
 * معالجة البيانات وتحويلها إلى الشكل المطلوب
 */

// ============== MAP EMPLOYEES ==============
export const mapEmployeesData = (employeesData) => {
  return (employeesData || []).map((emp) => ({
    id: emp.infinityCode || emp.id,
    name: emp.sr || "N/A",
    laborMode: emp.laborMode || "N/A",
    department: emp.department?.name ?? emp.location ?? "N/A",
    departmentId: emp.departmentId ?? null,
    position: emp.position ?? "N/A",
    email: emp.email || "N/A",
    phone: emp.phoneNumber || "N/A",
    salary: emp.netSalary || 0,
    joinDate: emp.hiringDate,
    status: emp.employeeState || "Active",
    company: emp.workingCompany || emp.clientName || "N/A",
    workingCompany: emp.workingCompany || "",
    arabicName: emp.arabicName || "N/A",
    avatar: getUserInitials(emp.sr),
    fullEmployeeData: emp,
  }));
};

// ============== MAP ARCHIVED EMPLOYEES ==============
export const mapArchivedEmployeesData = (archivedData) => {
  return (archivedData || []).map((emp) => ({
    id: emp.infinityCode || emp.id,
    name: emp.sr || "N/A",
    laborMode: emp.laborMode || "N/A",
    department: emp.department?.name ?? emp.location ?? "N/A",
    departmentId: emp.departmentId ?? null,
    position: emp.position ?? "N/A",
    email: emp.email || "N/A",
    phone: emp.phoneNumber || "N/A",
    salary: emp.netSalary || 0,
    joinDate: emp.hiringDate,
    status: "Archived",
    company: emp.clientName || "N/A",
    workingCompany: emp.workingCompany || "",
    archivedDate: emp.archivedDate || emp.created_at || new Date().toISOString(),
    avatar: getUserInitials(emp.sr),
  }));
};

// ============== COUNT NEW EMPLOYEES ==============
export const countNewEmployees = (employees) => {
  const now = Date.now();
  return (employees || []).filter(e => {
    const created = e.fullEmployeeData?.created_at || e.fullEmployeeData?.createdAt;
    if (!created) return false;
    const d = new Date(created);
    if (isNaN(d.getTime())) return false;
    const days = (now - d.getTime()) / (1000 * 60 * 60 * 24);
    return days <= 30;
  }).length;
};

// ============== GENERATE CSV TEMPLATE ==============
export const generateTemplateCSV = () => {
  const headers = [
    "English Name", "Client Name", "Client Code", "Infinity Code",
    "Arabic Name", "ID Region", "Employee Type", "Location", "National ID",
    "DOB", "Age", "Gender", "Phone number", "Emergency Phone Number",
    "Hiring Date", "Resigned Date", "Resign Reasons", "Be-Regular Date", "To Be Regular Or Not",
    "working age(year)", "working age(month)", "Period  for being regular", "labor mode", "Contract Company",
    "Contract Date", "Term of contract", "Contract Expiration", "beginning date for the insured", "Insurance Status",
    "months for insurance", "Insurance Number", "Insurance Salary", "Email", "Address",
    "City", "Country", "Religion", "Marital Status", "Nationality",
    "Graduate institutions and universities", "Major", "Graduation year", "ID Copy", "original copy of Graduation certificate",
    "Original and copy of birth certificate", "Original military service certificate", "Original labor letter", "No crime certificate", "6 Photos",
    "uniform size", "original copy of Form No.6", "Medical Check Form111", "Did Medical Check or Not", "Original copy of medical examination report",
    "Copy of lawyer's certificate", "Copy of driver's license", "Copy of Test engineer's certificate", "Copy of accountant certificate", "Militry Status",
    "Health Certificate For Office Boys", "Health Certificate Expiry Date", "Health Certificate Still Available or not", "Drive license Degree", "Driving License Expiry date",
    "Drive.License Still Available", "Date of last contract", "Term of last contract", "Expiration of last contract", "Medical Insurance Stage",
    "Delivered", "Medical Number", "Net Salary", "Account Number", "Employee state",
    "First Line Manager InfinityCode", "First Line Manager Name", "Second Line Manager InfinityCode", "Second Line Manager Name",
    "Arabic Address", "Transportation Allowances", "Variable Salary", "Working Company"
  ];
  
  const rows = Array(5).fill(headers.map(() => ""));
  return [headers.join(","), ...rows.map(row => row.join(","))].join("\n");
};
